import type { FormikErrors } from 'formik'

export type LocAndSvcsFormModel = {
  serviceLocationId: string
  serviceIds: Map<number, boolean>
  closeWin: 'open' | 'close'
  serviceType: 'oneTime' | 'recurring' | null
}

export const locAndSvcInitValues: LocAndSvcsFormModel = {
  serviceIds: new Map(),
  serviceLocationId: '',
  serviceType: null,
  closeWin: 'open',
}

export function validate(values: LocAndSvcsFormModel) {
  const { serviceIds, serviceLocationId } = values

  const errors: FormikErrors<LocAndSvcsFormModel> = {}

  if (serviceLocationId === '') {
    errors.serviceLocationId = 'Required'
  }

  const selected = [...serviceIds.values()].filter((x) => x).length

  if (selected === 0) {
    errors.serviceIds = 'Select at least one service'
  }

  return errors
}
